import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精彩视频</h2>
          <p className="mt-2 text-sm text-foreground-500">精选51大赛视频内容推荐</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {mediaItems.map((item, index) => (
            <div
              key={index}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative aspect-video overflow-hidden bg-background-300">
                <img
                  src={item.image}
                  alt={`51大赛 ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                <div className="absolute bottom-2 right-2 bg-black/70 backdrop-blur-sm text-white text-xs px-2 py-0.5 rounded-md">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-white ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug">{item.title}</h3>
                <div className="flex items-center gap-1.5 mt-2 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}